import { api, authHeader } from "../configs/axiosConfigs";

const unwrapPayload = (res) => res?.data?.data ?? res?.data ?? null;

const parseApiResult = (res, fallbackMessage = "") => ({
  ok: res?.data?.isSuccess === true,
  message: res?.data?.message || fallbackMessage,
  data: unwrapPayload(res),
});

const parseApiError = (error, fallbackMessage = "خطا در ارتباط با سرور") => {
  const data = error?.response?.data;
  const message =
    (typeof data?.message === "string" && data.message) ||
    (typeof data === "string" && data) ||
    error?.message ||
    fallbackMessage;
  return {
    ok: false,
    message,
    data: data?.data ?? null,
  };
};

const ApplicantContractApi = {
  listApplicantContracts: async (params = {}) => {
    const res = await api.request({
      url: "api/sln/applicant-contracts",
      method: "GET",
      params,
      headers: authHeader(),
    });
    return parseApiResult(res);
  },

  getApplicantContractByRequest: async (requestId) => {
    try {
      const res = await api.request({
        url: `api/sln/requests/${requestId}/applicant-contract`,
        method: "GET",
        headers: authHeader(),
      });
      return parseApiResult(res);
    } catch (error) {
      return parseApiError(error, "خطا در دریافت قرارداد متقاضی.");
    }
  },

  generateApplicantContract: async (requestId, options = {}) => {
    try {
      const res = await api.request({
        url: `api/sln/requests/${requestId}/applicant-contract/generate`,
        method: "POST",
        headers: authHeader(),
        timeout: 180000,
        data: {
          includeGridConnectionAndMeter: Boolean(
            options.includeGridConnectionAndMeter
          ),
          refreshEquipmentSnapshotFromLatestPackage: true,
          meterDayPriceRial: Number(options.meterDayPriceRial || 0),
          installationWageRial: Number(options.installationWageRial || 0),
          platformFeeRial: Number(options.platformFeeRial || 0),
          gridConnectionAndMeterFeeRial: Number(
            options.gridConnectionAndMeterFeeRial ||
              (Number(options.meterDayPriceRial || 0) +
                Number(options.installationWageRial || 0) +
                Number(options.platformFeeRial || 0))
          ),
        },
      });
      return parseApiResult(res, "خطا در تولید قرارداد متقاضی.");
    } catch (error) {
      if (error?.code === "ERR_NETWORK" || error?.message === "Network Error") {
        return {
          ok: false,
          message:
            "ارتباط با سرور قطع شد (احتمالاً API پس از تولید PDF ری‌استارت شده). صفحه را رفرش کنید؛ اگر نسخه جدید ساخته شده باشد نمایش داده می‌شود.",
          data: null,
        };
      }
      return parseApiError(error, "خطا در تولید قرارداد متقاضی.");
    }
  },

  previewApplicantContractHtml: async (requestId) => {
    const res = await api.request({
      url: `api/sln/requests/${requestId}/applicant-contract/preview-html`,
      method: "GET",
      headers: authHeader(),
      responseType: "text",
    });
    return {
      ok: typeof res?.data === "string" && res.data.length > 0,
      data: res?.data ?? "",
      message: "",
    };
  },

  downloadApplicantContractPdf: async (contractId) => {
    const res = await api.request({
      url: `api/sln/applicant-contracts/${contractId}/download-pdf`,
      method: "GET",
      headers: authHeader(),
      responseType: "blob",
    });
    return res?.data;
  },

  downloadApplicantContractDocx: async (contractId) => {
    const res = await api.request({
      url: `api/sln/applicant-contracts/${contractId}/download-docx`,
      method: "GET",
      headers: authHeader(),
      responseType: "blob",
    });
    return res?.data;
  },

  // Backward-compatible aliases
  getByRequest: async (requestId) =>
    ApplicantContractApi.getApplicantContractByRequest(requestId),

  generate: async (requestId, options) =>
    ApplicantContractApi.generateApplicantContract(requestId, options),

  downloadPdf: async (contractId) =>
    ApplicantContractApi.downloadApplicantContractPdf(contractId),
};

export default ApplicantContractApi;
